// Tick plan for daily date axes: every data point gets a label; labels are
// rotated when they can't sit side by side, and thinned only when even rotated
// labels would overlap.
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const FLAT_LABEL_PX = 64;
const ROTATED_LABEL_PX = 12;
export const ROTATED_AXIS_HEIGHT = 58;

export const isDailyDateData = (data) =>
    Array.isArray(data) && data.some((d) => d && d.label && /^\d{4}-\d{2}-\d{2}/.test(String(d.label)));

export const formatDayLabel = (value) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ""));
    return m ? `${parseInt(m[3], 10)} ${MONTHS[parseInt(m[2], 10) - 1]} ${m[1].slice(2)}` : String(value ?? "");
};

export function chronoTickPlan(data, width = 480) {
    const n = Math.max(1, data.length);
    const spacing = Math.max(1, width || 480) / n;
    const rotated = spacing < FLAT_LABEL_PX;
    const step = rotated ? Math.max(1, Math.ceil(ROTATED_LABEL_PX / spacing)) : 1;
    return { rotated, show: (idx) => idx % step === 0 || idx === n - 1 && (n - 1) % step >= step / 2 };
}

// tickFormatter variant used by recharts XAxis (pair with chronoAxisProps).
export function makeChronoFormatter(data, width) {
    if (!isDailyDateData(data)) return null;
    const { show } = chronoTickPlan(data, width);
    return (value, idx) => {
        const i = typeof idx === "number" ? idx : data.findIndex((d) => d.label === value);
        return show(i) ? formatDayLabel(value) : "";
    };
}

export const chronoAxisProps = { angle: -45, textAnchor: "end", height: ROTATED_AXIS_HEIGHT, interval: 0 };
